const global = {
  state: {
    headError: require('@/assets/img/defaultimg.png'), //默认头像
    isDD_env: dd.env.platform == 'notInDingTalk' ? false : true, //判读是否是钉钉环境  notInDingTalk：非钉钉环境
    // isDD_env: true,
    isWx_env: navigator.userAgent.toLowerCase().match(/MicroMessenger/i) != 'micromessenger' ? false : true,
    corpId: localStorage.getItem('corpId'),
    // appCode: 'kldsb',
    appCode: '',
    userId: localStorage.getItem('userId'),
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    schoolCode: localStorage.getItem('schoolCode'),
    // schoolCode: '1544',
    dingUserId: localStorage.getItem('dingUserId'),
  },
  mutations: {
    SET_CORPId: (state, corpId) => {
      state.corpId = corpId;
    },
    SET_USERINFO: (state, userInfo) => {
      state.userId = userInfo.userId;
      state.userInfo = userInfo;
    },
    SET_SCHOOLCODE: (state, schoolCode) => {
      state.schoolCode = schoolCode;
    },
    SET_DINGUSERID: (state, dingUserId) => {
      state.dingUserId = dingUserId;
    },
    SET_APPCODE: (state, appCode) => {
      state.appCode = appCode;
    },
  },
  actions: {
    setCorpId({ commit }, data) {
      localStorage.setItem('corpId', data);
      commit('SET_CORPId', data);
    },
    setUserInfo({ commit }, data) {
      localStorage.setItem('userId', data.userId);
      localStorage.setItem('userInfo', JSON.stringify(data));
      commit('SET_USERINFO', data);
    },
    setSchoolCode({ commit }, data) {
      localStorage.setItem('schoolCode', data);
      commit('SET_SCHOOLCODE', data);
    },
    setDingUserId({ commit }, data) {
      localStorage.setItem('dingUserId', data);
      commit('SET_DINGUSERID', data);
    },
    setAppCode({ commit }, data) {
      commit('SET_APPCODE', data);
    },
  },
};

export default global;
